<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__1968.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">1968</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_1968_HEADLINE')">Shiseido Global Innovation Centre</div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1968_TEXT_01')">
                    Conducts development of cosmetics, beauty foods, beauty devices, and beauty regimens, and basic
                    researches that support these developments.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1968_TEXT_02')">
                    Offers spaces for collaborative works with partners in different research areas and industry sectors
                    as well as for consumers.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1968_TEXT_03')">
                    Welcomes visitors to experience the latest research at facilities (such as Beauty Bar at where
                    visitors can create their own personalized cosmetics).
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1968_TEXT_04')">
                    In addition to this one, there are an additional 7 Shiseido innovation centres around the world
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-1968",
    }
</script>

<style scoped>

</style>